import { useState, useRef } from "react";
import "./FlashcardItem.css";

export default function FlashcardItem({ card, onDelete, onEdit, onViewDetail }) {
  const [flipped, setFlipped] = useState(false);
  const [isPlaying, setIsPlaying] = useState(false);
  const audioRef = useRef(null);

  const playAudio = () => {
    if (!card.voiceUrl) return;

    if (!audioRef.current) {
      audioRef.current = new Audio(card.voiceUrl);
      audioRef.current.onended = () => setIsPlaying(false);
    }

    audioRef.current.currentTime = 0;
    audioRef.current.play();
    setIsPlaying(true);
  };

  return (
    <div className="flashcard-container">
      <div className={`flashcard ${flipped ? "flipped" : ""}`}>
        <div className="front card flashcard-face shadow-sm">
          {card.imageUrl && (
            <img
              src={card.imageUrl}
              className="card-img-top flashcard-image"
              alt="flashcard"
            />
          )}
          {!card.imageUrl && (
            <div className="card-img-top flashcard-image flashcard-image-placeholder">
              <i className="bi bi-image fs-4"></i>
            </div>
          )}

          <div className="card-body d-flex flex-column">
            <div className="d-flex align-items-start justify-content-between gap-2 mb-2">
              <p
                className="card-title flashcard-title mb-0 text-clamp-2"
                onClick={(e) => {
                  e.stopPropagation();
                  onViewDetail?.(card);
                }}
              >
                {card.frontText}
              </p>

              {card.voiceUrl && (
                <button
                  className="btn btn-link flashcard-audio-btn p-0"
                  onClick={playAudio}
                  title="Play pronunciation"
                >
                  <i
                    className={`bi ${isPlaying ? "bi-volume-up-fill" : "bi-volume-up"} flashcard-audio-icon`}
                  />
                </button>
              )}
            </div>

            <div className="d-flex flex-wrap gap-2 mb-3">
              {card.transliteration && (
                <span
                  className="badge flashcard-badge flashcard-badge-info text-clamp-2"
                  onClick={(e) => {
                    e.stopPropagation();
                    onViewDetail?.(card);
                  }}
                >
                  {card.transliteration}
                </span>
              )}
              {card.categoryName && (
                <span className="badge flashcard-badge flashcard-badge-secondary text-clamp-2">
                  {card.categoryName}
                </span>
              )}
            </div>

            <div className="d-flex align-items-center gap-2 mt-auto">
              <button
                className="btn btn-primary btn-sm rounded-pill px-3"
                onClick={() => setFlipped(true)}
              >
                <i className="bi bi-arrow-repeat me-1"></i>
                Flip
              </button>

              <button
                className="btn btn-outline-primary btn-sm rounded-pill px-2"
                onClick={(e) => {
                  e.stopPropagation();
                  onViewDetail?.(card);
                }}
                title="View detail"
              >
                <i className="bi bi-eye"></i>
              </button>

              <button
                className="btn btn-outline-secondary btn-sm rounded-pill px-2"
                onClick={onEdit}
                title="Edit"
              >
                <i className="bi bi-pencil"></i>
              </button>

              <button
                className="btn btn-outline-danger btn-sm rounded-pill px-2 ms-auto"
                onClick={onDelete}
                title="Delete"
              >
                <i className="bi bi-trash3"></i>
              </button>
            </div>
          </div>
        </div>

        <div className="back card flashcard-face shadow-sm">
          <div className="card-body d-flex flex-column">
            <div className="mb-2 d-flex align-items-center justify-content-between gap-2">
              <h6 className="fw-semibold text-uppercase text-secondary mb-0">Definition</h6>
              <button
                className="btn btn-outline-primary btn-sm rounded-pill px-2"
                onClick={(e) => {
                  e.stopPropagation();
                  onViewDetail?.(card);
                }}
                title="View detail"
              >
                <i className="bi bi-eye"></i>
              </button>
            </div>

            <p
              className="text-muted mb-3 text-clamp-4 flashcard-back-text"
              onClick={(e) => {
                e.stopPropagation();
                onViewDetail?.(card);
              }}
            >
              {card.backText}
            </p>

            <div className="d-flex align-items-center gap-2 mt-auto">
              <button
                className="btn btn-primary btn-sm rounded-pill px-3"
                onClick={() => setFlipped(false)}
              >
                <i className="bi bi-arrow-counterclockwise me-1"></i>
                Back
              </button>

              {card.voiceUrl && (
                <button
                  className="btn btn-outline-secondary btn-sm rounded-pill px-2 ms-auto"
                  onClick={playAudio}
                  title="Play pronunciation"
                >
                  <i className={`bi ${isPlaying ? "bi-volume-up-fill" : "bi-volume-up"}`}></i>
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
